import React, { useState, Fragment, useEffect } from "react";
import { GetPriceList } from "../../../server/PriceList";
import { useSelector } from "react-redux";

const PricesCompareTable = ({ selectedProd }) => {
  const [company, setCompany] = useState([]);

  const { stationId, role } = useSelector((state) => ({
    stationId: state.user.stationId,
    role: state.user.role,
  }));

  useEffect(() => {
    getCompareData();
  }, [stationId]);

  const getCompareData = () => {
    GetPriceList(selectedProd.gtin, role)
      .then((data) => {
        let formattedData = Object.entries(data).flatMap(
          ([retailer, retailerData]) =>
            Object.entries(retailerData.branches).flatMap(
              ([branch, branchData]) =>
                branchData.prices.map((price) => ({
                  retailer,
                  branch,
                  retailerName: branchData.retailerName || retailer,
                  branchName: branchData.branchName,
                  price: price.price,
                  date: price.date,
                  promotionDescription: price.promotionDescription,
                }))
            )
        );

        // Find all "שערי רווחה" entries
        let shaareiRevachaEntries = formattedData.filter((entry) =>
          entry.retailerName.includes("שערי רווחה")
        );

        // If exactly 2 "שערי רווחה" entries exist and they have the same price, merge them
        if (
          shaareiRevachaEntries.length === 2 &&
          shaareiRevachaEntries[0].price === shaareiRevachaEntries[1].price
        ) {
          // Keep the first entry, update the retailerName, and remove the second
          shaareiRevachaEntries[0].branchName = null;

          formattedData = formattedData.filter(
            (entry) => entry !== shaareiRevachaEntries[1]
          );
        }

        setCompany(
          formattedData.sort(
            (a, b) =>
              parseFloat(a.price).toFixed(2) - parseFloat(b.price).toFixed(2)
          )
        );
      })
      .catch((error) => console.error("Error fetching price list:", error));
  };

  return company.length > 0 ? (
    <div className="price-compare-table">
      <h1 className="table-title">השוואת מחירים</h1>
      <div className="table-container">
        <table>
          <tbody>
            { selectedProd.pricing?.price &&
            <tr style={{ backgroundColor: "#white", fontWeight: "bold" }}>
              <td>המזון</td>
              <td
                style={{
                  textDecoration: selectedProd.pricing?.promotions?.length !== 0
                    ? "line-through"
                    : "none",
                }}
              >
              {selectedProd.pricing?.price && `${parseFloat(selectedProd.pricing?.price).toFixed(2)} ₪`}
              </td>
              <td
                style={{
                  backgroundColor: "white",
                  color: "#721c24",
                  fontWeight: "bold",
                }}
              >
                {" "}
                {selectedProd.pricing && selectedProd.pricing.promotions?.length !== 0 &&
                  `${selectedProd.pricing.promotions[0].toFixed(2)} ₪`}
              </td>
            </tr>}
            {company.map((store, index) => {
              const previousRowColor = index % 2 === 0 ? "#e0e0e0" : "white";
              return (
                <Fragment key={index}>
                  <tr style={{ backgroundColor: previousRowColor }}>
                    <td>
                      {store.branchName
                        ? `${store.retailerName} - ${store.branchName}`
                        : store.retailerName}
                    </td>
                    <td
                      style={
                        store.promotionDescription &&
                        /^\d+(\.\d{1,2})? ₪$/.test(store.promotionDescription)
                          ? { textDecoration: "line-through" }
                          : {}
                      }
                    >
                      {parseFloat(store.price).toFixed(2)} ₪
                    </td>
                    {store.promotionDescription ? (
                      <td>
                        <tr
                          className="sale-row"
                          style={{ backgroundColor: previousRowColor }}
                        >
                          <td colSpan={3}>{store.promotionDescription}</td>
                        </tr>
                      </td>
                    ) : (
                      <td></td>
                    )}
                  </tr>
                </Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  ) : null;
};

export default PricesCompareTable;
